export function snowFlakes(): void {
    const body = document.body;

    // If snowflakes are not enabled, stop everything
    if (!body.classList.contains('has-snowflakes')) {
        removeExistingSnowflakes();
        return;
    }

    // Start snowfall
    startSnow();
}

// Helper: start creating snowflakes
function startSnow() {
    // Prevent duplicates if already running
    if ((window as any)._snowInterval) return;

    (window as any)._snowInterval = setInterval(() => {
        createSnowflake();
    }, 600);
}

// Helper: remove old ones + stop interval
function removeExistingSnowflakes() {
    document.querySelectorAll('.snowflake').forEach(el => el.remove());
    clearInterval((window as any)._snowInterval);
    (window as any)._snowInterval = null;
}

// Your existing snowflake creation
function createSnowflake() {
    const snowflake = document.createElement('div');
    snowflake.classList.add('snowflake');
    snowflake.textContent = '❄';

    snowflake.style.left = Math.random() * 100 + 'vw';
    snowflake.style.fontSize = (Math.random() * 10 + 20) + 'px';
    snowflake.style.animationDuration = (Math.random() * 10 + 10) + 's';
    snowflake.style.opacity = Math.random() * 0.6 + 0.4;

    document.body.appendChild(snowflake);

    setTimeout(() => snowflake.remove(), 20000);
}
